import { TARGET } from './types';

const SAVE_FILE_CLEANUP_TIMEOUT = 500;

function saveBlobInIE(blob: any, fileName: string): void {
    window.navigator.msSaveOrOpenBlob(blob, fileName);
}

function onSaveFileCleanup(link: HTMLAnchorElement): void {
    document.body.removeChild(link);
    window.URL.revokeObjectURL(link.href);
}

function saveBlobViaLink(blob: any, fileName: string): void {
    const link = document.createElement('a');
    link.style.display = 'none';
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link); // this is necessary for firefox
    link.click();
    setTimeout(() => onSaveFileCleanup(link), SAVE_FILE_CLEANUP_TIMEOUT);
}

export function saveBlob(blob: any, fileName: string): void {
    if (typeof window.navigator.msSaveOrOpenBlob === 'function') {
        saveBlobInIE(blob, fileName);
        return;
    }

    saveBlobViaLink(blob, fileName);
}

export interface RevokeCallback {
    revoke(): void;
}

export function openBlobInBrowserTab(blob: Blob, target: TARGET = TARGET.BLANK): RevokeCallback {
    const url = window.URL.createObjectURL(blob);
    const revoke = (): void => window.URL.revokeObjectURL(url);

    const link = document.createElement('a');
    link.style.display = 'none';
    link.href = url;
    link.target = target;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    return { revoke };
}
